import { Chip } from '@material-ui/core';
import { Product } from '@setvi/shared/interfaces';

interface StockInfoProps {
  stockInfo: Product['stockInfo'];
}

export const getStockInfo = ({
  allWarehouses = false,
  warehouses
}: Product['stockInfo']) => {
  if (allWarehouses) return 'Stock';

  const warehousesWithStock = warehouses.filter(warehouse => warehouse.stock);

  if (warehousesWithStock?.length > 0)
    return `Stock - ${warehousesWithStock?.[0]?.warehouseName}`;

  return 'Non Stock';
};

export const StockInfo = ({ stockInfo }: StockInfoProps) => {
  if (!stockInfo) return null;

  return (
    <Chip variant="outlined" size="small" label={getStockInfo(stockInfo)} />
  );
};
